<div class="helpbg cdbg2">
  <div class="helpbgLR cdbg2">
      <div class="helpdiv cdbg2">
          <div class="py-5 text-center container">
            <div class="row justify-content-center">
              <div class="col-10 col-lg-8">
                <h3 class="text-white">Hubungi Cepatdapet</h3>
                <h4 class="text-white">Kami senang mendengar dari Anda, silakan hubungi kami.</h4>                
              </div>
            </div>
          </div>
      </div>
  </div>
</div>
<div class="bg-white">
  <div class="container mb-3 mb-sm-5">
    <div class="row justify-content-center">
      <div class="col-md-8 p-3 p-sm-5">
        <div class="boxContact p-3 p-sm-5">
          <form [formGroup]="contactForm" id="contactDiv" (ngSubmit)="onSubmit()">

            <div class="row justify-content-center">
              <div class="col-sm-12">

                <div class="form-group mb-3">
                  <label for="name">{{'contact.name' | translate}}</label>
                  <input type="text" placeholder="{{'contact.name_placeholder' | translate}}" [(ngModel)]="ValName" formControlName="name"  maxlength="200" class="form-control" [ngClass]="{ 'is-invalid': submitted && f?.name?.errors }" />
                  <div
                  class="errtxt"
                  role="alert"
                  *ngIf="submitted && f?.name?.errors"
                  >
                  <div *ngIf="f?.name?.errors?.required">{{'contact.name' | translate}} {{'required' | translate}}</div>
                  </div>
                </div>
  
              </div>
              <div class="col-sm-6">

                <div class="form-group mb-3">
                  <label for="phone">{{'contact.phone' | translate}}</label>
                  <input type="text" placeholder="{{'contact.phone_placeholder' | translate}}" [(ngModel)]="ValPhone" formControlName="phone"  maxlength="20" class="form-control" [ngClass]="{ 'is-invalid': submitted && f?.phone?.errors }" />
                  <div
                  class="errtxt"
                  role="alert"
                  *ngIf="submitted && f?.phone?.errors"
                  >
                  <div *ngIf="f?.phone?.errors?.required">{{'contact.phone' | translate}} {{'required' | translate}}</div>
                  </div>
                </div>
  
              </div>
              <div class="col-sm-6">
                
                <div class="form-group mb-3">
                  <label for="email">{{'contact.email' | translate}}</label>
                  <input type="text" placeholder="{{'contact.email_placeholder' | translate}}" [(ngModel)]="ValEmail" formControlName="email" maxlength="200" class="form-control" [ngClass]="{ 'is-invalid': submitted && f?.email?.errors }" />
                  <div
                  class="errtxt"
                  role="alert"
                  *ngIf="submitted && f?.email?.errors"
                  >
                  <div *ngIf="f?.email?.errors?.required">{{'contact.email' | translate}} {{'required' | translate}}</div>
                  <div *ngIf="f?.email?.errors?.pattern">{{'contact.email' | translate}} {{'invalid_email' | translate}}</div>
                  </div>
                </div>                

              </div>
              <div class="col-sm-12">
                
                <div class="form-group mb-3">
                  <label for="subject">{{'contact.subject' | translate}}</label>
                  <input type="text" placeholder="{{'contact.subject_placeholder' | translate}}" [(ngModel)]="ValSubject"  maxlength="200" formControlName="subject" class="form-control" [ngClass]="{ 'is-invalid': submitted && f?.subject?.errors }" />
                  <div
                  class="errtxt"
                  role="alert"
                  *ngIf="submitted && f?.subject?.errors"
                  >
                  <div *ngIf="f?.subject?.errors?.required">{{'contact.subject' | translate}} {{'required' | translate}}</div>
                  </div>
                </div>

              </div>
              <div class="col-sm-12">
                
                <div class="form-group mb-3">
                  <label for="message">{{'contact.message' | translate}}</label>
                  <!-- <input type="text" placeholder="Tuliskan pesan" [(ngModel)]="ValMessage" formControlName="message" class="form-control" [ngClass]="{ 'is-invalid': submitted && f?.message?.errors }" />
                  <div
                  class="errtxt"
                  role="alert"
                  *ngIf="submitted && f?.message?.errors"
                  >
                  <div *ngIf="f?.message?.errors?.required">Message is required</div>
                  </div> -->


                  <textarea [(ngModel)]="ValMessage" formControlName="message" class="form-control" [ngClass]="{ 'is-invalid': submitted && f?.message?.errors }" placeholder="{{'contact.message_placeholder' | translate}}" row="4" maxlength="1000"></textarea>
                  <div *ngIf="submitted && f?.message?.errors" class="invalid-feedback">
                      <div class="errtxt" role="alert" *ngIf="f?.message?.errors?.required">{{'contact.message' | translate}} {{'required' | translate}}</div>
                  </div>

                </div>

              </div>
              <div class="col-12">

                <div class="form-group">
                  <div class="row g-0">
                    <div class="col-12">
                      <div class="form-check">
                        <input
                          #checkboxContact
                          class="form-check-input"
                          type="checkbox"
                          [(ngModel)]="ValisContactable"
                          [ngModelOptions]="{standalone: true}"
                          id="flexCheckChecked"
                        />
                        <label class="form-check-label" for="flexCheckChecked">
                          {{'contact.contactable' | translate}}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                                
              </div>
              <div class="col-md-5">


                <div class="form-group mt-3">
                  <button *ngIf="!pageloading" class="f1 btn btn-secondary btn-block w-100 btnContact pt-2 pb-2">
                      Kirim Pesan
                  </button>
                  <button *ngIf="pageloading" class="f1 btn btn-secondary btn-block w-100 btnContact pt-2 pb-2" disabled>
                  Loading..
                  </button>
                </div>
  

              </div>
            </div>

          </form> 
        </div>
      </div>
    </div>
  </div>
</div>